//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dbmap from '@/assets/dbs/hashmap.js'
export default {
    data () {
        return {
            
        }
    },
    mounted(){
    },
    methods:{
        btnBack(){
            this.$router.push("/index")
        },
    }
}




// WEBPACK FOOTER //
// ./src/view/complete.vue